// Serviço para operações de despesas financeiras - usa axios `api` para consistência
import api from './api';

export const fetchDespesas = async (params = {}) => {
  try {
    const response = await api.get('/despesas', { params });
    const raw = response.data;

    // Normalizar respostas com data + pagination
    if (!raw) return { despesas: [], pagination: { page: 1, limit: params.limit || 10, total: 0, totalPages: 0 } };
    if (raw.success && Array.isArray(raw.data)) {
      return { despesas: raw.data, pagination: raw.pagination || { page: params.page || 1, limit: params.limit || 10, total: 0, totalPages: 0 } };
    }
    if (raw.despesas && Array.isArray(raw.despesas)) {
      return { despesas: raw.despesas, pagination: raw.pagination || { page: params.page || 1, limit: params.limit || 10, total: raw.total || 0, totalPages: raw.totalPages || 0 } };
    }

    // Fallbacks
    if (Array.isArray(raw)) return { despesas: raw, pagination: { page: params.page || 1, limit: params.limit || 10, total: raw.length, totalPages: 1 } };

    return { despesas: [], pagination: { page: params.page || 1, limit: params.limit || 10, total: 0, totalPages: 0 } };
  } catch (error) {
    console.error('Erro ao buscar despesas:', error);
    return { despesas: [], pagination: { page: params.page || 1, limit: params.limit || 10, total: 0, totalPages: 0 } };
  }
};

export const fetchDespesaById = async (id) => {
  try {
    const response = await api.get(`/despesas/${id}`);
    const raw = response.data;
    if (raw && raw.success && raw.data) return raw.data;
    if (raw) return raw;
    throw new Error('Despesa não encontrada');
  } catch (error) {
    console.error('Erro ao buscar despesa por id:', error);
    throw error;
  }
};

export const createDespesa = async (despesaData) => {
  try {
    const response = await api.post('/despesas', despesaData);
    const raw = response.data;
    if (raw && raw.success && raw.data) return raw.data;
    return raw;
  } catch (error) {
    console.error('Erro ao criar despesa:', error);
    throw error;
  }
};

export const updateDespesa = async (id, despesaData) => {
  try {
    const response = await api.put(`/despesas/${id}`, despesaData);
    const raw = response.data;
    if (raw && raw.success && raw.data) return raw.data;
    return raw;
  } catch (error) {
    console.error('Erro ao atualizar despesa:', error);
    throw error;
  }
};

export const deleteDespesa = async (id) => {
  try {
    const response = await api.delete(`/despesas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar despesa:', error);
    throw error;
  }
};

export const fetchContasDespesa = async () => {
  try {
    // 1) Tentar buscar diretamente contas do tipo 'Saida'
    try {
      const respTipo = await api.get('/contas', { params: { page: 1, limit: 1000, tipo: 'Saida' } });
      const rawTipo = respTipo.data;
      if (rawTipo) {
        if (rawTipo.contas && Array.isArray(rawTipo.contas) && rawTipo.contas.length > 0) return rawTipo.contas;
        if (Array.isArray(rawTipo) && rawTipo.length > 0) return rawTipo;
      }
    } catch (err) {
      console.warn('fetchContasDespesa: erro buscando /contas?tipo=Saida ->', err.message);
    }

    // 2) Tentar buscar /contas sem filtro (pode trazer campo `tipo`) e filtrar localmente
    try {
      const respAllPaged = await api.get('/contas', { params: { page: 1, limit: 1000 } });
      const rawPaged = respAllPaged.data;
      if (rawPaged) {
        const contasArray = Array.isArray(rawPaged.contas) ? rawPaged.contas : (Array.isArray(rawPaged) ? rawPaged : []);
        if (contasArray.length > 0) {
          // Se os itens tiverem o campo `tipo`, filtrar por 'Saida'
          if (contasArray[0] && Object.prototype.hasOwnProperty.call(contasArray[0], 'tipo')) {
            const filtradas = contasArray.filter(c => (c.tipo || '').toString().toLowerCase() === 'saida');
            return filtradas;
          }
          // Se não houver campo `tipo`, tentaremos fallback para /contas/all
        }
      }
    } catch (err) {
      console.warn('fetchContasDespesa: erro buscando /contas (paged) ->', err.message);
    }

    // 3) Fallback para /contas/all
    try {
      const responseAll = await api.get('/contas/all');
      const rawAll = responseAll.data;
      if (!rawAll) return [];
      if (Array.isArray(rawAll)) return rawAll;
      if (Array.isArray(rawAll.contas)) return rawAll.contas;
      if (rawAll.success && rawAll.data) {
        if (Array.isArray(rawAll.data.contas)) return rawAll.data.contas;
        if (Array.isArray(rawAll.data)) return rawAll.data;
      }
      if (Array.isArray(rawAll.data)) return rawAll.data;
      // Se chegamos aqui e ainda não temos tipo, retornar o que houver (não ideal)
      console.warn('fetchContasDespesa: /contas/all retornou items sem campo `tipo`; retornando todas as contas (verifique dados)');
      return rawAll;
    } catch (err) {
      console.error('fetchContasDespesa: falha final ao buscar contas ->', err.message);
      return [];
    }
  } catch (error) {
    console.error('Erro ao buscar contas de despesa:', error);
    return [];
  }
};

export const fetchDespesasStats = async () => {
  try {
    const response = await api.get('/despesas/stats');
    const raw = response.data;
    if (raw && raw.success && raw.data) return raw.data;
    if (raw && raw.data) return raw.data;
    return { total: 0, count: 0, average: 0 };
  } catch (error) {
    console.error('Erro ao buscar estatísticas de despesas:', error);
    return { total: 0, count: 0, average: 0 };
  }
};

export const fetchDespesasByFilters = async (filters) => {
  return fetchDespesas(filters);
};

const despesaService = {
  fetchDespesas,
  fetchDespesaById,
  createDespesa,
  updateDespesa,
  deleteDespesa,
  fetchContasDespesa,
  fetchDespesasStats,
  fetchDespesasByFilters
};

export default despesaService;
